// app/javascript/controllers/shift_checkbox_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["master"]
  static values = {
    selector: { type: String, default: "input[type='checkbox']" }
  }

  connect() {
    this.lastChecked = null
    this.syncMaster()
  }

  toggle(event) {
    const current = event.target
    const checkboxes = this.memberCheckboxes()
    if (!checkboxes.includes(current)) return

    if (event.shiftKey && this.lastChecked) {
      const start = checkboxes.indexOf(this.lastChecked)
      const end = checkboxes.indexOf(current)
      if (start >= 0 && end >= 0) {
        const [min, max] = [start, end].sort((a, b) => a - b)
        for (let i = min; i <= max; i++) {
          if (!checkboxes[i].disabled) {
            checkboxes[i].checked = this.lastChecked.checked
          }
        }
      }
    }

    this.lastChecked = current
    this.syncMaster()
  }

  toggleAll(event) {
    const desired = event.target.checked
    this.memberCheckboxes().forEach((checkbox) => {
      if (!checkbox.disabled) checkbox.checked = desired
    })
    this.lastChecked = null
    this.syncMaster()
  }

  memberCheckboxes() {
    return Array.from(this.element.querySelectorAll(this.selectorValue)).filter((checkbox) => {
      if (!(checkbox instanceof HTMLInputElement)) return false
      if (checkbox.type !== "checkbox") return false
      if (this.hasMasterTarget && checkbox === this.masterTarget) return false
      return true
    })
  }

  syncMaster() {
    if (!this.hasMasterTarget) return

    const checkboxes = this.memberCheckboxes().filter((checkbox) => !checkbox.disabled)
    if (checkboxes.length === 0) {
      this.masterTarget.checked = false
      this.masterTarget.indeterminate = false
      return
    }

    const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length
    this.masterTarget.checked = checkedCount === checkboxes.length
    this.masterTarget.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length
  }
}
